/* Noorns redesign: the blog index topic filter (sections/noorns-blog.liquid), driven by the shared
   topic pills (snippets/noorns-topic-pills.liquid, assets/noorns-topic-pills.js).
   Every card is in the page once. Picking a topic moves the matching cards into the
   three-to-a-row grid (as small cards) and hides the main layout; "All posts" puts each card
   back where it was, with its own size. The hero's article count follows the filter.
   ?topic=<key> opens a topic. Without this script every post shows. */
(function () {
  var row = document.getElementById('blog-topics');
  var lay = document.getElementById('blog-layout'), fl = document.getElementById('blog-filtered');
  if (!row || !lay || !fl || !window.noornsPills) return;
  var cards = Array.prototype.slice.call(lay.querySelectorAll('a[data-topics]'));
  cards.forEach(function (c) {
    c._slot = document.createComment('card');
    c.parentNode.insertBefore(c._slot, c);
    c._cls = c.className;
  });
  var count = document.getElementById('blog-hero-count');
  var count0 = count ? count.textContent : '';
  function restore() {
    cards.forEach(function (c) {
      c.className = c._cls; c.hidden = false;
      c._slot.parentNode.insertBefore(c, c._slot.nextSibling);
    });
  }
  window.noornsPills(row, function (t) {
    restore();
    if (t === 'all') {
      lay.hidden = false; fl.hidden = true;
      if (count) count.textContent = count0;
      return;
    }
    var n = 0;
    cards.forEach(function (c) {
      if ((' ' + c.getAttribute('data-topics') + ' ').indexOf(' ' + t + ' ') >= 0) {
        c.className = c._cls.replace(/\b(feature|card2)\b/, 'card3');
        fl.appendChild(c);
        n++;
      }
    });
    lay.hidden = true; fl.hidden = false;
    if (count) count.textContent = n + (n === 1 ? ' article' : ' articles') + ', newest first';
  });
})();
